import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        search: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedWebFormStates: [],
        selectedTags: [],
        selectedPaymentOptions: [],
        selectedPaymentStates: [],
        selectedOptionTypes: [],
        cadh: null,
        emailSearch: null,
    }
}

const cadhFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setSearch(state, value) {
            state.search = value
        },
        setEmailSearch(state, value) {
            state.emailSearch = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedWebFormStates(state, value) {
            state.selectedWebFormStates = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setSelectedPaymentOptions(state, value) {
            state.selectedPaymentOptions = value
        },
        setSelectedPaymentStates(state, value) {
            state.selectedPaymentStates = value
        },
        setSelectedOptionTypes(state, value) {
            state.selectedOptionTypes = value
        },
        setCadh(state, value) {
            state.cadh = value
        },
        pushWebFormState(state, value) {
            if(!state.selectedWebFormStates.includes(value)) {
                state.selectedWebFormStates.push(value)
            }
        },
        pushFormState(state, value) {
            if(!state.selectedWebFormStates.includes(value)) {
                state.selectedWebFormStates.push(value)
            }
        },
        removeUnavailableStates(state) {
            let availables = ['WITHOUT_EMAIL', 'WITHOUT_WEB_FORM']

            state.selectedWebFormStates = state.selectedWebFormStates.filter(_state => availables.includes(_state))
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default cadhFilter